import { Box, Typography } from "@mui/material";
import numberFormat from "../../../components/globalFunction/prettierNumber";

const Products = ({ data }) => {
  return data.products.map((e, i) => (
    <Box
      key={i}
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        bgcolor: "background.paper",
        borderBottom: "1px solid #ccc",
        padding: "10px",
      }}
    >
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            width: "30px",
            height: "30px",
            backgroundColor: "rgba(3, 134, 129, 0.22)",
            borderRadius: "50%",
          }}
        >
          <Typography>{i + 1}</Typography>
        </Box>
        <Typography variant="body2">{e.name}</Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "5px",
          justifyContent: "center",
        }}
      >
        <Typography fontWeight={"bold"}>{e.amount}</Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "5px",
          justifyContent: "center",
        }}
      >
        <Typography fontWeight={"bold"}>{numberFormat(e.price)}</Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "5px",
          justifyContent: "center",
        }}
      >
        <Typography fontWeight={"bold"}>
          {numberFormat(e.price * e.amount)}
        </Typography>
      </Box>

      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "5px",
          justifyContent: "center",
        }}
      >
        <Typography fontWeight={"bold"}>
          {data.createdOrder.products[i].amount}
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "5px",
          justifyContent: "center",
        }}
      >
        <Typography fontWeight={"bold"}>
          {numberFormat(data.createdOrder.products[i].price)}
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "5px",
          justifyContent: "center",
        }}
      >
        <Typography fontWeight={"bold"}>
          {numberFormat(
            data.createdOrder.products[i].price *
              data.createdOrder.products[i].amount
          )}
        </Typography>
      </Box>
    </Box>
  ));
};

export default Products;
